export default "/corgi/pageapps/purchase/_next/static/media/arrow-left.e9735d79.svg";